import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { PermissionGroupModel } from 'app/models/permission-group.model';

@Injectable({
    providedIn: 'root',
})
export class PermissionGroupService extends BaseService<PermissionGroupModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'permission-group');
    }
}



